import { ComponentBlock } from '@types';

import { types } from '@application/core/types';

import { component } from './component';
import { LineChartProps } from '.';

export const block: ComponentBlock<'lineChart', LineChartProps, unknown> = {
  id: 'lineChart',
  render: component,
  props: {
    chartCategory: {
      type: types.string,
    },
    chartCategoryLabel: {
      type: types.string,
    },
    chartValue: {
      type: types.string,
    },
    chartValueLabel: {
      type: types.string,
    },
    chartData: {
      type: types.list,
    },
  },
};
